export default {
  path: '/stock',
  title: '库存管理',
  icon: 'bank',
  children: [{
    path: '/stock/detail/consign',
    title: '寄售库存管理',
    icon: 'th-large'
  }]
};